import React from 'react'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout'

import './MyBatteryMap.css'
import { BackButton } from '@/components/layout/NavBar'
import BatteryMapComponent from '@/components/Map/BatteryMap'

export const MyBatteryMapPage = ({ services, session }: { services: Services, session: CurrentSession }) => {
  // const { translates } = session

  return <LoggedInPageLayout pageName='my-battery-map' services={services} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>

    <div className='default-map-container'>
      <BatteryMapComponent fetchUrl='/api/communal/my/map' services={services} session={session} />
    </div>
  </LoggedInPageLayout>
}
